import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { useFilterContext } from 'src/contexts/FilterContext';

export const ClearFiltersButton: React.FC = () => {
  const { timeRangeLocked, mediaLocked, campaignsLocked, resetFilters } =
    useFilterContext();

  const hasLockedFilters = timeRangeLocked || mediaLocked || campaignsLocked;

  if (!hasLockedFilters) {
    return null;
  }

  return (
    <Button
      buttonName="clear-filters"
      variant="ghost"
      size="sm"
      leftIcon={<Icon iconName="close" boxSize={3} />}
      onClick={resetFilters}
      color="red.500"
      _hover={{ bg: 'red.50' }}>
      Clear Filters
    </Button>
  );
};
